module.exports = __webpack_public_path__ + "static/media/dvustranen.ea929e03.pdf";